"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ownerOptionFormatter = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _classnames = _interopRequireDefault(require("classnames"));

var _isEmpty = _interopRequireDefault(require("transmute/isEmpty"));

var _once = _interopRequireDefault(require("transmute/once"));

var OwnerIdOptions = _interopRequireWildcard(require("customer-data-objects/owners/OwnerIdOptions"));

var _react = _interopRequireWildcard(require("react"));

var _ReferenceInputEnum = _interopRequireDefault(require("customer-data-reference-ui-components/ReferenceInputEnum"));

var _ReferenceResolverType = _interopRequireDefault(require("reference-resolvers/schema/ReferenceResolverType"));

var _I18n = _interopRequireDefault(require("I18n"));

var _isActiveOwner = require("customer-data-objects/owners/isActiveOwner");

var getPlaceholder = (0, _once.default)(function () {
  return OwnerIdOptions.getNoneOption().label;
});

var ownerOptionFormatter = function ownerOptionFormatter(option) {
  var selectOption = {
    text: option.get('label'),
    value: option.get('id'),
    help: option.get('description')
  };
  var owner = option.referencedObject;

  if ((0, _isActiveOwner.isOnlyActiveSalesforceOwner)(owner)) {
    selectOption.text = option.get('label') + " " + _I18n.default.text('customerDataProperties.PropertyInput.owner.SalesforceOwner');
  } else if (!(0, _isActiveOwner.isActiveHubSpotOwner)(owner)) {
    selectOption.text = option.get('label') + " " + _I18n.default.text('customerDataProperties.PropertyInput.owner.deactivatedOwner');
  }

  return selectOption;
};

exports.ownerOptionFormatter = ownerOptionFormatter;
var propTypes = {
  className: _react.PropTypes.string,
  id: _react.PropTypes.string,
  onChange: _react.PropTypes.func.isRequired,
  resolver: _ReferenceResolverType.default,
  value: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string])
};

var PropertyInputOwner =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(PropertyInputOwner, _Component);

  function PropertyInputOwner() {
    (0, _classCallCheck2.default)(this, PropertyInputOwner);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(PropertyInputOwner).apply(this, arguments));
  }

  (0, _createClass2.default)(PropertyInputOwner, [{
    key: "focus",
    value: function focus() {
      return this.refs.input.focus();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          rest = (0, _objectWithoutProperties2.default)(_this$props, ["className"]);
      var value = this.props.value ? this.props.value.toString() : undefined;
      return _react.default.createElement(_ReferenceInputEnum.default, (0, _extends2.default)({}, rest, {
        className: (0, _classnames.default)(className, {
          noValue: (0, _isEmpty.default)(value)
        }),
        clearable: true,
        menuWidth: "auto",
        multi: false,
        optionFormatter: ownerOptionFormatter,
        placeholder: getPlaceholder(),
        ref: "input",
        value: value
      }));
    }
  }]);
  return PropertyInputOwner;
}(_react.Component);

exports.default = PropertyInputOwner;
PropertyInputOwner.propTypes = propTypes;